// extracted by css-extract-rspack-plugin
export default {"container":"cQToOmZLgteebqdJ__container___","label":"YsJxVIZRsim3yBRn__label___","optionDescription":"EwJVwqcPN_MlBWCw__optionDescription___"};